"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMaxDaresByPlatform = void 0;
const calculateMaxDares_1 = require("root/src/shared/util/calculateMaxDares");
const useDropEvent_1 = require("root/src/client/logic/dropEvent/hooks/useDropEvent");
const platforms_1 = require("root/src/shared/@types/platforms");
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
function useMaxDaresByPlatform({ platform = platforms_1.DarePlatform.Any, dropEvent }) {
    var _a, _b;
    const { connectedPlatforms, averageCcv, } = (0, useUser_1.useUserCreatorData)();
    const maxFollowerCount = (0, useUser_1.useMaxCreatorFollowerCount)();
    const followerCountByPlatform = (0, useUser_1.useCreatorFollowersCountByPlatform)();
    const campaign = (_a = (0, useDropEvent_1.useDropEvent)()) !== null && _a !== void 0 ? _a : dropEvent;
    if (!campaign || !platform) {
        return 0;
    }
    if (platform === platforms_1.DarePlatform.Any) {
        const bestPlatform = (0, calculateMaxDares_1.calculateMaxDaresForBestPlatform)({
            followerCount: maxFollowerCount,
            averageCcv: averageCcv || 0,
            campaign,
            connectedPlatforms,
        });
        return (_b = bestPlatform === null || bestPlatform === void 0 ? void 0 : bestPlatform.maxDares) !== null && _b !== void 0 ? _b : 0;
    }
    return (0, calculateMaxDares_1.calculateMaxDaresByPlatform)({
        platform,
        averageCcv: averageCcv || 0,
        followerCount: followerCountByPlatform[platform],
        campaign,
    });
}
exports.useMaxDaresByPlatform = useMaxDaresByPlatform;
